import React from "react";
import { Helmet } from "react-helmet-async";

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  url?: string;
  image?: string;
  type?: string;
  author?: string;
  structuredData?: object;
}

const SEO: React.FC<SEOProps> = ({
  title = "GaadiKharcha.com - Gaadi Ki Kamaai Aur Kharcha - Ab Finger Tip Par",
  description = "Gaadi Ki Kamaai Aur Kharcha - Ab Finger Tip Par. Track booking, maintenance, fuel consumption, and staff management. Gaadi Ki Kamaai Aur Kharcha - Ab Finger Tip Par. Complete transport business solution.",
  keywords = "vehicle management, fleet tracking, transport business, booking management, maintenance tracking, fuel monitoring, driver management, gaadi kharcha, vehicle expense tracking, transport software, fleet management system",
  url = "https://gaadikharcha.com",
  image = "/logo512.png",
  type = "website",
  author = "GaadiKharcha.com",
  structuredData,
}) => {
  const fullImageUrl = image.startsWith("http") ? image : `${url}${image}`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImageUrl} />
      <meta property="og:site_name" content="GaadiKharcha.com" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={fullImageUrl} />

      {/* Canonical URL */}
      <link rel="canonical" href={url} />

      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
